<template>
  <section>
    <CreateForm v-model:form-state="formState" />

    <footer>
      <a-button :disabled="hasChanges" @click="handleCancel"> Cancelar </a-button>

      <a-button type="primary" :disabled="hasChanges" :loading="loading" @click="handleSave">
        Guardar cambios
      </a-button>
    </footer>
  </section>
</template>

<script setup lang="ts">
import { inject, computed, ref } from "vue";
import type { Ref } from "vue";
import { useRoute } from "vue-router";
import { message } from "ant-design-vue";

import type { Form } from "@/@types/entities/forms";
import type { FormCreateBody } from "@/@types/entities/forms/services";
import { formService } from "@/app/entities/services";
import { ResponseError } from "@/app/shared/utils/httpManager";

import CreateForm from "@/app/entities/components/modals/forms/forms/CreateForm.vue";

const emit = defineEmits<{
  (e: "update"): void;
}>();

const route = useRoute();

const formDetail = inject("formDetail") as Ref<Form | undefined>;

const formState = ref<FormCreateBody>({
  name: formDetail.value?.name,
  description: formDetail.value?.description,
});

const hasChanges = computed(() => {
  const name = formState.value.name;
  const description = formState.value.description;

  return formDetail.value?.name === name && formDetail.value?.description === description;
});

const handleCancel = () => {
  formState.value.name = formDetail.value?.name;
  formState.value.description = formDetail.value?.description;
};

const loading = ref(false);

const handleSave = async () => {
  loading.value = true;

  try {
    const newForm: FormCreateBody = {
      name: formState.value?.name,
      description: formState.value?.description,
    };

    await formService.edit(Number(route.params.id), newForm);
    emit("update");

    message.success("Se han guardado los cambios");
  } catch (error) {
    let errorMessage = "No se pudieron guardar los cambios";

    if (error instanceof ResponseError) {
      console.error(error.data);
      errorMessage = error.getErrorMessage();
    }

    message.error(errorMessage);
  }

  loading.value = false;
};
</script>

<style scoped lang="sass">
section
  display: flex
  flex-direction: column
  justify-content: space-between
  height: calc(100% - 38px)

footer
  display: flex
  align-items: center
  justify-content: flex-end
  gap: 0 12px
  padding: 12px 0
  border-top: 1px solid $gray-5
</style>
